import { render, staticRenderFns } from "./DCTakePhoto.vue?vue&type=template&id=058bc826&scoped=true&"
import script from "./DCTakePhoto.vue?vue&type=script&lang=js&"
export * from "./DCTakePhoto.vue?vue&type=script&lang=js&"
import style0 from "./DCTakePhoto.vue?vue&type=style&index=0&id=058bc826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058bc826",
  null
  
)

export default component.exports